<template>
    <b-card no-body class="m-0" border-variant="white">
        <b-card-body class="pb-0">
            <slot />
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    name: 'KeyResultsContainer',
}
</script>
